import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function Categories() {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        axios.get('https://laravel-api.petra-ms.com/api/categories')
            .then(response => {
                if (response.data.success) {
                    setCategories(response.data.data);
                }
            })
            .catch(error => {
                console.error('Error fetching categories:', error);
            });
    }, []);

    return (
        <section className="relative py-10">
            <div className="container">
                <div className="text-2xl font-bold text-[#20BCB4] mb-5">Main Categories</div>
                <Swiper
                    slidesPerView={3}
                    spaceBetween={10}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        300: { slidesPerView: 2 },
                        500: { slidesPerView: 3 },
                        750: { slidesPerView: 4 },
                        1000: { slidesPerView: 5 },
                        1250: { slidesPerView: 6 },
                    }}
                    className="overflow-hidden"
                >
                    {categories.map((el) => (
                        <SwiperSlide key={el.id}>
                            <Link
                                to={`/menu-list/${el.id}`} // تمرير معرف الفئة في الرابط
                                className="bg-white rounded-lg shadow-md overflow-hidden"
                            >
                                <div className="h-[150px]">
                                    <img
                                        className="w-full h-full object-cover"
                                        src={`https://laravel-api.petra-ms.com/storage/app/public/${el.category_img}`}
                                        alt={el.category_name}
                                    />
                                </div>
                                <div className="p-4 text-center font-bold">{el.category_name}</div>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}